import {
    UPDATEWITHDRWALCOUNT_SUCCESS,
    UPDATEWITHDRWALCOUNT_FAILED,
    RESET_UPDATEWITHDRWALCOUNT,
    LOADING_UPDATEWITHDRWALCOUNT,
    NETWORK_ERROR_UPDATEWITHDRWALCOUNT,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetUpdateWithdrawalCount = () => {
    return { type: RESET_UPDATEWITHDRWALCOUNT };
};

const updateWithdrawalCount = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_UPDATEWITHDRWALCOUNT });
    await partnerServices
        .post("updateWithDrawalCount", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(updateWithdrawalCountsuccess(res.data));
                    break;
                default:
                    dispatch(updateWithdrawalCountFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_UPDATEWITHDRWALCOUNT, payload: err });
        });
};
function updateWithdrawalCountsuccess(data) {
    return {
        type: UPDATEWITHDRWALCOUNT_SUCCESS,
        payload: data,
    };
}
function updateWithdrawalCountFailed(data) {
    return {
        type: UPDATEWITHDRWALCOUNT_FAILED,
        payload: data,
    };
}

export { resetUpdateWithdrawalCount, updateWithdrawalCount };
